import { createAction, props } from '@ngrx/store';

import { FertilizationLegalStandards } from '../models/legal-standard.model';

export const getFertilizationLegalStandards = createAction(
  '[Legal standards] Get fertilization legal standards',
);

export const triggerDelayedGetFertilizationLegalStandards = createAction(
  '[Legal standards] Trigger delayed get fertilization legal standards',
);

export const setFertilizationLegalStandards = createAction(
  '[Legal standards] Set fertilization legal standards',
  props<{ fertilizationLegalStandards: FertilizationLegalStandards }>(),
);
